/**
 * @learnzapp/core/welcome — post-sign-in welcome modal logic: the show/hide
 * predicate, per-exam free/total/premium count math, and the Free-vs-Premium
 * column builder. Both apps derive the modal from these so the promised free
 * access is byte-identical across web and mobile.
 */
export * from './welcomeSummary';
